const invoice = {
    // headings
    createStudentInvoice: 'Create Student Invoice',
    createCompanyInvoice: 'Create Company Invoice',
    createBatchInvoice: 'Create Batch Invoices',
    editStudentInvoice: 'Edit Student Invoice',
    editCompanyInvoice: 'Edit Company Invoice',
    show: 'Invoice',

    // List
    invoices: 'Invoices',
    allInvoices: 'List of All Invoices',
    batchInvoicesList: 'Batch Invoices List',
    allStudentInvoices: 'List of All Student Invoices',
    allCompanyInvoices: 'List of All Company Invoices',
    studentPaidInvoices: 'Student Paid Invoices',
    studentPendingInvoices: 'Student Pending Invoices',
    studentUnpaidInvoices: 'Student Unpaid Invoices',
    emailed: 'E-mailed invoices',
    companyPaidInvoices: 'Company Paid Invoices',
    companyUnpaidInvoices: 'Company Unpaid Invoices',
    searchCriteria: 'Filter Preset',
    invoiceNumber: 'Invoice Number',
    invoiceDate: 'Invoice Date',
    type: 'Assigned To',
    amount: 'Amount',
    currency: 'Currency',
    paid: 'Paid',
    unpaid: 'Unpaid',
    select: '--Select--',
    yes: 'Yes',
    no: 'No',
    paymentDate: 'Payment Date',
    scheduledDeliveryDate: 'Scheduled Delivery Date & Time',
    deliveryDate: 'Delivery Date & Time',

    sendInvoice: 'Send Invoice by E-Mail',
    presetName: 'Enter Preset Name',
    date: 'Date',
    number: 'Number',
    viewInvoice: 'View Invoice',
    action: 'Action',
    company: 'Company',
    view: 'View',
    approveInvoice:'Approve invoice',
    xInvoicesApproved:'{X} invoice(s) successfully approved.',

    // Tabs
    tabGeneral: 'General',
    tabAudit: 'Audit Log',

    // Labels
    invoiceNo: 'INVOICE No.',
    zurich: 'Zurich,',
    dear: 'Dear',
    makePaymentText: 'We kindly ask you to make the payment for the following:',
    bankDetails: 'Our bank details:',
    exemptedFromVAT: 'Exempted from VAT under Article 14.9.',
    askForPaymentText: 'We kindly ask you to make the above payment',
    until: 'until',
    by:'by',
    thankForCollaboration: 'Thank you for your kind collaboration.',
    invoiceNumber: 'Invoice Number',
    student: 'Student',
    mailAddress: 'Mail Address',
    personalAddress: 'Personal Address',
    businessAddress: 'Business Address',
    tuitionPurpose: 'Program Purpose For Flex MBA',
    MBACourses: 'MBA Courses',
    fromDate: 'From Date',
    toDate: 'To Date',
    DateTime: 'Date & Time',
    exclude_scholarship_reduction:'Exclude invoice from scholarship reduction',
    invoicePurpose: 'Invoice Purpose',
    InvoiceInfo: 'Additional Invoice Info',
    customPurpose: `Program fees for {title}, {date}, Flex MBA program`,
    termPurpose: `Tuition fees, Semester {semester}, {programType}, {program}`,
    termPurposeBatch: `Tuition fees, Semester {semester}, {programType}`,
    coursePurpose: `Tuition fees, {course}, {programType}, {program}`,
    acceptancePurpose: `Administration Fee, {programType}, {program}`,
    applicationPurpose: `Application Fee, {programType}, {program}`,
    coursePurposeBatch: `Tuition fees, {course}, {programType}`,
    amount: 'Amount',
    discount: 'Scholarship',
    fullDiscount: 'Full Payment Discount',
    discountedAmount: 'Amount after scholarship deduction',
    amountAfterDeductibles: 'Amount after transfer credit deductions',
    amountAfterDeductiblesAndScholarship:'Amount after scholarship and transfer credit deductions',
    fullDiscountedAmount: 'Amount after full payment and administration fee deduction',
    currency: 'Currency',
    dueDate: 'Due Date',
    payment: 'Payment Plan',
    installment: 'Installment',
    companyName: 'Company Name',
    searchCompany: 'Search Company by Name',
    globalDiscountInfo: 'The student has a {discount}% global scholarship reduction',
    fullPaymentDiscountInfo: ' and a {fullPaymentDiscount}% full payment discount.',
    applyDiscount: 'Should apply again?',
    status: 'Status',
    send_status:'Send Status',
    status_pending: 'Pending',
    status_approved: 'Approved',
    status_sent: 'Sent',
    status_paid: 'Paid',
    status_course_date_pending: 'Course Date Pending',
    status_delivery_failed: 'Delivery Failed',
    invoice_deleted:'Invoice has been deleted',
    less_scholarship:'less Scholarship',
    less_full_payment_discount:'less Full Payment Discount',
    less_administration_fee: 'less Administration Fee (invoiced separately)',
    course_date_pending:'Course Date Pending',
    apply_payment_plan_reduction:'Apply payment plan reduction logic',
    warning_apply_payment_plan_reduction:'This will remove the payment plan specific scholarship reduction logic for this invoice.  The scholarship percentage will be deducted directly from the amount of this invoice.',
    // batch
    program: 'Program',
    programType: 'Program Type',
    selectStudents: 'Select students',
    selectInvoices: 'Select Invoices',
    discounted: 'Discounted',
    remove: 'Invoice has been removed successfully.',
    studentNumber: 'Student Number',
    studentName: 'Student Name',
    name: 'Name',
    tuition_for_full_payment_invoices:'Tuition fees for {ProgramType}, {ProgramTitle}, {ProgramYear}',
    tuition_for_deductible_course: 'Tuition fees for {CourseCode}-{CourseTitle} {CourseFrom} - {CourseTo},{ProgramType} Program',
    less_deductible:'less TC for {CourseTitle} ({CourseCode})',
    zero_amount:'00.00',
    tuition_for_semester_deductible_course: 'Tuition fees for Semester {Semester} ,{ProgramType} Program , {SemesterFrom} - {SemesterTo}',
    deductible_credits_not_supported:'Please note: deductible transfer credits are not automatically deducted using this payment plan.',
    editing: 'Editing <strong>{name}</strong> Invoice',
    installmentText: 'Installment {num} of {total}',
    courses: 'Courses',
    terms: 'Semester/Term',
    acceptanceFee: 'Administration Fee',
    applicationFee: 'Application Fee',
    newPurpose: 'Enter invoice purpose here if none applicable in above list.',
    bankingFees: 'When making payments, kindly make sure to take over all banking fees and indicate the invoice number.',
    course: 'Course',
    atleastoneselected:'Please select at least one invoice to approve.',
    waittonotify:'Please wait for few moments as invoices are being emailed.',
    total:'Total',
    with_grant:'(with grant)',
    total_for_semester:'Total for Semester {SemesterNo}',
    paymentPlanBatchAlreadyExists:'There are already existing payment plan invoices. This will create another batch of payment plan invoices. Do you still wish to continue?',
    paymentPlanFPBatchAlreadyExists:'There are already existing payment plan (foundation program) invoices. This will create another batch of payment plan (foundation program) invoices. Do you still wish to continue?',
    purposeOverwrittenWarning:'The existing invoice purpose text will be overwritten. Do you want to continue?',
    course:'Course',
    studentNo:'Student Number',

};

export default invoice;
